import React from 'react'
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useSessionStore } from '../../hooks/useSessionStore';
import { UsuarioContext } from '../../contexts/UsuarioContext';
import axios from 'axios';

export const PaqueteOfrecido = (props) => {
    const { paquete, setPaquete, setModalAnadirServicio, generarListaDias, getPeriodos, comprobaciones, setModalAnadirPaqueteServicioShareCare } = props;
    const [Usuario, setUsuario] = useSessionStore(UsuarioContext);
    return (<>
        <Accordion>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
            >
                <div className='servicio-perfil-empresa'>
                    <div className='centradorLeft'>
                        <h5>
                            {paquete.nombrePaquete}
                        </h5>

                    </div>
                    <div className='centradorLeft'>Precio: {paquete.precio} €</div>
                    {/* <div className='extras-servicioOfrecido-perfilAgencia-nuevo'>
                        {
                            (paquete.domicilio) &&
                            <div className='centrador'>
                                <div className='domicilio-servicioOfrecido-perfilAgencia-nuevo'>
                                    Domicilio
                                </div>
                            </div>
                        }
                        {
                            (paquete.shareCare) &&
                            <div className='centrador'>
                                <div className='shareCare-servicioOfrecido-perfilAgencia-nuevo'>
                                    ShareCare
                                </div>
                            </div>
                        }
                    </div> */}
                </div>
            </AccordionSummary>
            <AccordionDetails>
                <Typography>
                    <div className='cuerpo-descripcion-servicio'>
                        <div className='centradorLeft descripcion-servicio'>{paquete.descripcion}</div>
                        <div className='centradorRight'>
                            <div className='button icono-comprar-servicio'
                                onClick={() => {
                                    if (comprobaciones() == true) {
                                        if(Usuario.tipo==='usuarioNormal'){
                                            axios({
                                              // Sending a post request to the server. 
                                              method: 'post',
                                              url: window.ipdirection + 'logs?logstream=clickAnadirServicio',
                                              headers: {
                                                  "Authorization": "Bearer " + Usuario.access
                                              },
                                              data: { 'usuario': Usuario.cliente.usuario.id, 'infoServicio': paquete.servicio_id, 'accion': 'clickAnadirServicio'},
                                            }).then((response) => {
                                        
                                            }).catch(error => {
                                            })
                                          }
                                          setPaquete(paquete);
                                        //getPeriodos(paquete.id);
                                        //generarListaDias(paquete.id);
                                        // comprobamos el tipo de paquete
                                        setModalAnadirPaqueteServicioShareCare(true);
                                    }
                                }}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" fill="currentColor" class="bi bi-bag-fill" viewBox="0 0 16 16">
                                    <path d="M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1zm3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4h-3.5z" />
                                </svg>
                                <div className="centrador"><b>Añadir</b></div>
                            </div>
                        </div>
                    </div>
                </Typography>
            </AccordionDetails>
        </Accordion>
    </>)
}
